import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/page';

export const Route = createFileRoute('/_app/_chat/apps/')({
  component: Page,
});
